/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Action constants types.
 */
const PREFIX = 'aduanas';
export const NOTIFY = `${PREFIX}_notify`;
export const FETCH_DATA = `${PREFIX}_fetch_data`;
export const FETCH_COMPLETE = `${PREFIX}_fetch_complete`;



// WEBPACK FOOTER //
// ./containers/aduanas/types.js